<template>
    <div>
        <Accounts></Accounts>
    </div>
</template>

<script>
    import Accounts from './Accounts.vue'

    export default {
        components: {
            Accounts
        },

        data: () => ({})
    }
</script>





// WEBPACK FOOTER //
// src/pages/Home.vue